export default "__VITE_ASSET__a490cdb4__"